import React, { useImperativeHandle, useState, useRef } from 'react';
import { CustomerResourceAddDialog } from '@Local/CustomerResource/Dialog/';
import useForkRef from '@Util/hook/useForkRef';

const CustomerResourceAddDialogBox = React.forwardRef((props, ref) => {
    const dialogRef = useRef(null);
    const combinedRef = useForkRef(ref, dialogRef);
    const [openDialog, setOpenDialog] = useState('');
    const [sourceData, setSourceData] = useState({});
    const refreshRef = useRef(null);

    const doRefresh = () => {
        if (refreshRef.current && typeof refreshRef.current === 'function') refreshRef.current();
    };

    useImperativeHandle(
        combinedRef,
        () => {
            return {
                openCustomerResourceDialog: (targetData, _refreshFn = () => {}) => {
                    setSourceData(targetData);
                    setOpenDialog('customerResource');
                    refreshRef.current = _refreshFn;
                },
                closeDialog: () => handleCloseDialog(),
            };
        },
        // eslint-disable-next-line
        [],
    );

    const handleCloseDialog = () => {
        setOpenDialog(null);
        setSourceData(null);
        refreshRef.current = null;
    };

    return (
        <React.Fragment>
            <CustomerResourceAddDialog open={openDialog === 'customerResource'} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
        </React.Fragment>
    );
});

export default CustomerResourceAddDialogBox;    
